module.exports = __webpack_public_path__ + "static/Welcome-e35e50145978a2a8bbf24c95418782e5.mp4";